import Cookies from "js-cookie";

import configs from "../config";
import { AppDomainConfig } from "../envConfig";
import { ParentOptions } from "../model/app/propTypes";

export default function getEnvParent(
  parameters = new URLSearchParams(window.location.search),
):
  | {
      config: AppDomainConfig;
      parentOptions: ParentOptions;
    }
  | undefined {
  const parent = parameters.get("parent");
  if (!parent) {
    return undefined;
  }

  const referrer = document.referrer || Cookies.get("referrer");
  const config = Object.values(configs).find((conf) => {
    let allowedRegex = conf.allowedParentApplications;
    if (allowedRegex) {
      allowedRegex += "|localhost|deploy-preview";
    }
    return allowedRegex && new RegExp(`(${allowedRegex})`).test(referrer);
  });

  if (!referrer) {
    // eslint-disable-next-line no-console
    console.warn("No referrer value to test");
  }

  if (!config) {
    return undefined;
  }

  Cookies.remove("referrer");
  Cookies.set("referrer", referrer);

  return {
    config,
    parentOptions: config.getParentOptions(parent),
  };
}
